const api: string = "https://shareyourstory-backend.onrender.com";
export default api;
